// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"page_pageWrap__3gmVP"};